import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaChartLine,
  FaEnvelope,
  FaHandshake,
  FaLifeRing,
  FaUserShield,
  FaUsers,
} from "react-icons/fa";

const Sidebar = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const links = [
    {
      name: "Dashboard",
      to: "/admin/dashboard",
      icon: <FaChartLine color="#4caf50" />,
    },
    {
      name: "Quota Usage",
      to: "/admin/quotaUsage",
      icon: <FaUserShield color="#2196f3" />,
    },
    {
      name: "Email Data",
      to: "/admin/email-data",
      icon: <FaEnvelope color="#9c6bff" />,
    },
    {
      name: "Leads",
      to: "/admin/leads",
      icon: <FaUsers color="#ff9800" />,
    },
    {
      name: "Partner Query",
      to: "/admin/partner-query",
      icon: <FaHandshake color="#00bcd4" />,
    },
    {
      name: "Support",
      to: "/admin/support",
      icon: <FaLifeRing color="#f44336" />,
    },
  ];

  return (
    <div
      style={{
        // width: "220px",
        minHeight: "calc(100vh - 56px)",
        backgroundColor: "#212529",
        color: "white",
      }}
    >
      <ul className="list-unstyled p-3 mt-4 mb-0">
        <h5 className="mx-2">Admin Panel</h5>
        <hr className="m-1" />
        {links.map((link) => {
          const isActive = pathname === link.to;

          return (
            <li
              key={link.to}
              className={`p-2 d-flex align-items-center ${
                isActive ? "bg-light text-dark" : ""
              }`}
            >
              <Link
                to={link.to}
                className="text-decoration-none d-flex align-items-center w-100"
                style={{
                  color: isActive ? "#000" : "#fff",
                  fontSize: ".8rem",
                  fontWeight: "200",
                }}
              >
                <span className="me-2" style={{ fontSize: "1rem" }}>
                  {link.icon}
                </span>
                {link.name}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Sidebar;
